/*
 ** Author: Munyingi Ian
 ** Author URL: https://ellixar.com/
 */

import React, { Component } from "react";
import LoginRegister from "../LoginRegisterModal";
import Auth from "../../modules/Auth/userToken";

class TopNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      login: true,
      registershopowner: false
    };
  }
  showHideModal = () => {
    this.setState({ modalShow: false });
  };

  loginClicked = () => {
    this.setState({ modalShow: true, login: true, registershopowner:false });
  };
  registerClicked = () => {
    this.setState({ modalShow: true, login: false, registershopowner:false });
  };
  registerShopOwnerClicked =() => {
    this.setState({modalShow: true, login: false, registershopowner: true})
  }
  logout = () => {
    Auth.logout()
  };

  render() {
    return (
      <div className={`top_nav ${this.props.className}`}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="top_nav_left">
                We charge a nominal convenience fee for accessing Mechanics.
              </div>
            </div>
            <div className="col-md-6 text-right">
              <div className="top_nav_right">
                <ul className="top_nav_menu">
                  {Auth.getUserDetails() == undefined && Auth.getUserDetails() == null ? (
                    <><li className="currency">
                      <a href="/mech-register">
                        Sign up as Mechanic
                      </a>
                    </li>
                    <li className="currency">
                    <a href="#" onClick={() => this.registerShopOwnerClicked()}>
                            <i
                              className="fa fa-user-plus"
                              aria-hidden="true"
                            ></i>
                             Shop Owner Sign Up
                          </a>
                      </li></>
                  ) : (
                    <div></div>
                  )}

                  {/* <li className="language">
                    <a href="#">
                      English
                      <i className="fa fa-angle-down"></i>
                    </a>
                    <ul className="language_selection">
                      <li>
                        <a href="#">French</a>
                      </li>
                      <li>
                        <a href="#">Italian</a>
                      </li>
                      <li>
                        <a href="#">German</a>
                      </li>
                      <li>
                        <a href="#">Spanish</a>
                      </li>
                    </ul>
                  </li> */}
                  {Auth.getUserDetails() !== undefined &&
                    Auth.getUserDetails() !== null ? (
                    <ul className="top_nav_menu">
                      <li className="currency">
                        <a href="/profile">
                          {`Karibu ${Auth.getUserDetails().firstName}`}
                          <i className="fa fa-user"></i>
                        </a>
                      </li>
                      <li className="currency">
                        <a href="#" onClick={() => this.logout()}>
                          Logout
                          <i
                            className="fas fa-sign-out-alt"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  ) : (
                    <li className="account">
                      <a href="#">
                        Sign In | Sign Up
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <ul className="account_selection">
                        <li>
                          <a href="#" onClick={() => this.loginClicked()}>
                            <i
                              className="fas fa-sign-in-alt"
                              aria-hidden="true"
                            ></i>
                            Sign In
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={() => this.registerClicked()}>
                            <i
                              className="fa fa-user-plus"
                              aria-hidden="true"
                            ></i>
                            Sign Up
                          </a>
                        </li>
                      </ul>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {this.state.modalShow ? (
          <LoginRegister
            show={this.state.modalShow}
            login={this.state.login}
            registershopowner={this.state.registershopowner}
            registerClicked={() => this.registerClicked()}
            loginClicked={() => this.loginClicked()}
            registerShopOwnerClicked={() => this.registerShopOwnerClicked()}
            onHide={() => this.showHideModal()}
          />
        ) : null}
      </div>
    );
  }
}

export default TopNavBar;
